export const IS_ADDRESS_REGISTERED = 'IS_ADDRESS_REGISTERED';
export const isAddressRegistered = q => ({
  type: IS_ADDRESS_REGISTERED,
  payload: q
});
